module.exports = __webpack_public_path__ + "static/neil-armstrong-8b7c59b8b1a225b9bab26d568f154d2f.jpg";